export default {
      id: "icon-column-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons.svg#icon-column",
      toString: function () {
        return this.url;
      }
    }